import { Component, Type } from '@angular/core';
import { ClientConfigService, IconService } from './shared';
import { DocumentViewerService, DocumentViewerState } from './shared/services/document.viewer.service';

@Component({
  selector: 'flow-sync-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  public title: string = 'flow-sync';
  /** The floating WhatsApp chat, loaded only for clients with a Conversations page. */
  public chatFab: Type<unknown> | null = null;
  public viewerState: DocumentViewerState = { isOpen: false, documentUrl: null, documentName: null };

  constructor(
      private readonly iconService: IconService,
      private readonly clientConfig: ClientConfigService,
      private readonly documentViewerService: DocumentViewerService,
  ) {
    this.documentViewerService.viewerState$.subscribe(state => this.viewerState = state);
    if (this.clientConfig.getNavItems().some(item => item.routePath === 'conversations')) {
      void import('./features/components/customer-chat-fab/customer-chat-fab.component')
        .then(m => this.chatFab = m.CustomerChatFabComponent);
    }
  }

  public closeViewer(): void {
    this.documentViewerService.closeDocumentViewer();
  }
}
